import React from 'react';
import './Disclaimer.css';

function Disclaimer() {
  return (
    <div>We are a group of volunteers with lived experience of sight loss. WE ARE NOT A REGISTERED CHARITY OR COMPANY AT THIS TIME. We live locally to Derbyshire and want to help.</div>
  )
}

export default Disclaimer